import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container-fluid",
  style: {"margin-top":"80px","padding-top":"20px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "text-muted" }
const _hoisted_5 = { class: "col-lg-6 d-flex flex-column justify-content-end" }
const _hoisted_6 = {
  class: "mt-5 navbar navbar-light navbar-expand-md",
  style: {"background-color":"rgba(0, 0, 0, 0.03)","border":"1px solid rgba(0, 0, 0, 0.125)","border-bottom":"0"},
  role: "navigation"
}
const _hoisted_7 = {
  class: "form-inline my-2 my-lg-0 ml-auto",
  role: "search"
}
const _hoisted_8 = { style: {"height":"calc(100vh - 300px)"} }

import $ from "jquery"
    import { computed, watch, onMounted, onUnmounted, nextTick, ref, type Ref } from "vue"
    import { useRoute } from "vue-router"

    import CorporateNavigation from "@common/Components/CorporateNavigation.vue"
    import ScenarioNavigation from "@Quest/CorporateScenarios/Components/ScenarioNavigation.vue"

    import { useSchedulingPageQueryV1 } from "@Quest/CorporateScenarios/queries-vue-composables"

    import type {
        ScenarioItemReadModel,
        SchedulingPageReadModel
    } from "@Quest/CorporateScenarios/readmodels"


    // ======================
    // Route
    // ======================

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SchedulingPage',
  setup(__props) {

    const route = useRoute()

    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const strategyId = computed(() => String(route.params.strategyId ?? ""))
    const scenarioId = computed(() => String(route.params.scenarioId ?? ""))


    // ======================
    // Query
    // ======================

    const {
        runSchedulingPageQueryV1,
        modelSchedulingPageQueryV1
    } = useSchedulingPageQueryV1(workspaceId, strategyId, scenarioId)

    const rm = modelSchedulingPageQueryV1 as Ref<SchedulingPageReadModel | null>

    // ======================
    // Local State
    // ======================

    const searchPhrase = ref<string | null>(null)


    // ======================
    // Computed
    // ======================

    const projectsView = computed<ScenarioItemReadModel[]>(() =>
    {
        const items = rm.value?.Items ?? []
        let view = [...items]

        if (searchPhrase.value)
        {
            const phrase = searchPhrase.value.toLowerCase()
            view = view.filter(a =>
                a.Name.toLowerCase().indexOf(phrase) > -1
            )
        }

        return view
    })

    const ds = computed(() =>
    {
        if (!rm.value) return []

        return projectsView.value
            .filter(a => a.StartDate && a.EndDate)
            .map(a => ({
                id: a.Id,
                title: a.Name,
                start: new Date(a.StartDate!),
                end: new Date(a.EndDate!)
            }))
    })


    // ======================
    // Gantt Handling
    // ======================

    const ganttRef = ref<HTMLElement | null>(null)

    function edit(e: any)
    {
        const selection = e.sender.select()
        const task = e.sender.dataItem(selection)
    }

    function ensureGantt()
    {
        const el = ganttRef.value
        if (!el) return

        const existing = ($(el) as any).data("kendoGantt")

        if (existing)
        {
            existing.setDataSource(
                new kendo.data.GanttDataSource({ data: ds.value })
            )
            return
        }

        ($(el) as any).kendoGantt({
            editable: false,
            height: "100%",
            tooltip: { visible: false },
            views: [{ type: "year", selected: true }],
            columns: [
                { field: "title", title: "Name", sortable: true },
                { field: "start", title: "Start", format: "{0:MM/yyyy}", sortable: true, width: 120 },
                { field: "end", title: "End", format: "{0:MM/yyyy}", sortable: true, width: 120 }
            ],
            dataSource: ds.value,
            change: (e: any) => edit(e)
        })
    }


    // ======================
    // Watchers
    // ======================

    watch(rm, async (current, previous) =>
    {
        if (current && !previous)
        {
            await nextTick()
            ensureGantt()
        }
    })

    watch(ds, () =>
    {
        nextTick(() => ensureGantt())
    })


    function onScheduled(result: any)
    {
        runSchedulingPageQueryV1()
    }


    // ======================
    // Lifecycle
    // ======================

    onMounted(() =>
    {
        document.title = "Enterprise Plan - Schedule"
        runSchedulingPageQueryV1()
    })

    onUnmounted(() =>
    {
        const el = ganttRef.value
        const gantt = ($(el) as any)?.data("kendoGantt")
        if (gantt) gantt.destroy()
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(CorporateNavigation, { ActivePage: "dashboard" }),
    (_unref(rm))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("small", _hoisted_4, "Enterprise Plan: " + _toDisplayString(_unref(rm).ScenarioName), 1 /* TEXT */),
              _cache[1] || (_cache[1] = _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }, "Schedule", -1 /* CACHED */))
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(ScenarioNavigation, { onScheduled: onScheduled })
            ])
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
          _createElementVNode("nav", _hoisted_6, [
            _createElementVNode("form", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                class: "form-control mr-sm-2",
                type: "search",
                placeholder: "Search",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchPhrase).value = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, searchPhrase.value]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              ref_key: "ganttRef",
              ref: ganttRef,
              style: {"height":"100%"}
            }, null, 512 /* NEED_PATCH */)
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})